import { JsonLd } from '../JsonLd';

export interface FaqEntry {
  question: string;
  answer: string;
}

export function FAQPageLd({ items }: { items: FaqEntry[] }) {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((entry) => ({
      '@type': 'Question',
      name: entry.question,
      acceptedAnswer: { '@type': 'Answer', text: entry.answer },
    })),
  };
  return <JsonLd schema={data} />;
}
